import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import VerticalLayout from "components/VerticalLayout";
import axios from "axios";

//constants
import { layoutTypes } from "../../constants/layout";

const Authmiddleware = (props) => {

  const { layoutType } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
  }));

  const getLayout = (layoutType) => {
    let Layout = VerticalLayout;
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout;
        break;
      case layoutTypes.HORIZONTAL:
        Layout = HorizontalLayout;
        break;
      default:
        break;
    }
    return Layout;
  };

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        sessionStorage.setItem("atsuser-info", c.substring(name.length, c.length));
        let roles = localStorage.getItem('RolesFromDb');
        sessionStorage.setItem("RolesFromDb", roles);
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }


  let token;

  const cookieValue = getCookie("userinfoCookie");
  if (cookieValue) {
    try {
      const userInfo = JSON.parse(cookieValue);
      token = userInfo.token;

      if (token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      }
    } catch (err) {
      console.error("Invalid cookie JSON:", err);
    }
  }
  
  const navigate = useNavigate();
  useEffect(() => {
    if (getCookie("userinfoCookie")) {

    } else {
      sessionStorage.removeItem("atsuser-info");
      sessionStorage.removeItem("RolesFromDb");
      localStorage.removeItem("RolesFromDb");
    }

  }, [props])


  // useEffect(() => {
  //   if (getCookie("userinfoCookie")) {

  //   } else {
  //    
  //   }

  // }, [])

  // let token;
  // if (getCookie("userinfoCookie")) {
  //   var tempobject = getCookie("userinfoCookie");
  //   tempobject = JSON.parse(tempobject)

  //   token = tempobject.token
  //   axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }
  // }

  // let userinfo = JSON.parse(sessionStorage.getItem('atsuser-info'))

  // if (sessionStorage.getItem("atsuser-info")) {
  //   axios.defaults.headers.common = { 'Authorization': `Bearer ${userinfo.token}` }
  // }

  const Layout = getLayout(layoutType);

  // if (!userinfo) {
  //   return (
  //     <Navigate to={{ pathname: "/", state: { from: props.location } }} />
  //   );
  // }

  return (
    <>
      {!getCookie("userinfoCookie") ? <><Navigate to={{ pathname: "/", state: { from: props.location } }} /></> :
        <>
          <Layout>{props.children}</Layout>
        </>
      }


      {/* <React.Fragment>
      
      </React.Fragment> */}

    </>



  );
};

export default Authmiddleware;
